// extracted by mini-css-extract-plugin
export default {"counterWrapper":"Counter_counterWrapper__sqVBV","display":"Counter_display__7Hr0w"};